import { JSX } from "react";

import Box from "@mui/material/Box";
import {
  SubconfigurationNavigation,
  SubconfigurationNavigationProps,
} from "@plansoft-configuration-renderer/components";

import { CustomSubconfigurationNavigation } from "./CustomSubconfigurationNavigation";

export function SubconfigurationNavigationMapper(
  props: SubconfigurationNavigationProps,
): JSX.Element {
  const { custom } = props;

  if (custom?.isCustomSubconfigurationNavigation) {
    return (
      <Box
        className="custom-subconfiguration-navigation"
        sx={{
          display: "flex",
          minHeight: "100%",
        }}
      >
        <CustomSubconfigurationNavigation {...props} />
      </Box>
    );
  }

  return <SubconfigurationNavigation {...props} />;
}
